var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconICards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4791",
    "data-name": "Group 4791",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 6.171,
    height: 12.343,
    viewBox: "0 0 6.171 12.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1060",
    "data-name": "Rectangle 1060",
    width: 6.171,
    height: 12.343,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4790",
    "data-name": "Group 4790",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7622",
    "data-name": "Path 7622",
    d: "M6.171,40.127a2.575,2.575,0,0,1-1.22,1.131,3.347,3.347,0,0,1-2.868.215A1.846,1.846,0,0,1,.866,39.285q.434-2.183.928-4.354c.121-.529.015-.836-.551-.952a9.717,9.717,0,0,1-.975-.319c-.158-.05-.292-.12-.264-.311.025-.172.177-.186.309-.187,1.468-.005,2.935-.018,4.4,0,.475.005.332.373.276.636-.306,1.452-.623,2.9-.937,4.352-.02.093-.038.186-.056.28-.279,1.4.3,1.985,1.7,1.727.141-.026.275-.149.469-.03",
    transform: "translate(0 -29.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7623",
    "data-name": "Path 7623",
    d: "M20.84,3.27a1.624,1.624,0,0,1-1.63-1.628,1.642,1.642,0,1,1,3.284.026,1.624,1.624,0,0,1-1.654,1.6",
    transform: "translate(-17.012 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconICards);
export default __webpack_public_path__ + "static/media/icon_i_cards.321166c3ffbc128b8623433ac9300d59.svg";
export { ForwardRef as ReactComponent };